export default function runtimeToSeconds(runTime = '00:00:00') {
  const time = runTime.split(':');
  return +time[0] * 60 * 60 + +time[1] * 60 + +time[2];
}
